// extracted by mini-css-extract-plugin
module.exports = {"section":"DataSettings_section__1-JwD","accent":"DataSettings_accent__LkMda"};